// extracted by mini-css-extract-plugin
export default {"dialogPaper":"AddTopicModal_dialogPaper__UtCI+","footer":"AddTopicModal_footer__158Fn"};